import { $, CustomEventWithoutDetail } from 'rune-ts';
import intervalToDuration from 'date-fns/intervalToDuration/index.js';
import differenceInDays from 'date-fns/differenceInDays/index.js';
import { BaseButtonAction, BaseButtonProps } from './BaseButtonAction';
import { IntervalTimer } from '../../../../util/timer';

export interface BaseDateButtonProps extends BaseButtonProps {
  end: string;
  start: string;
  is_lazy_timer?: boolean;
  is_mobile?: boolean;
}

export class DateEndEvent extends CustomEventWithoutDetail {}

export class BaseDateButtonAction<
  T extends BaseDateButtonProps = BaseDateButtonProps,
> extends BaseButtonAction<T> {
  private timer?: IntervalTimer;

  protected override onRender() {
    if (!this.data.is_lazy_timer) {
      this.timer = new IntervalTimer(1000, {
        onTick: this.onTick.bind(this),
      });

      this.timer?.start();
    }
  }

  static diff(end_at: string, start_at: string): [number, number, number, number] {
    try {
      const start = new Date(start_at);
      const end = new Date(end_at);

      if (start.getTime() >= end.getTime()) return [0, 0, 0, 0];

      const {
        hours = 0,
        minutes = 0,
        seconds = 0,
      } = intervalToDuration({
        start,
        end,
      });
      const days = differenceInDays(end, start);

      return [days, hours, minutes, seconds];
    } catch (e) {
      return [0, 0, 0, 0];
    }
  }

  static convertLabel(
    {
      days,
      hours,
      minutes,
      seconds,
    }: {
      days: number;
      hours: number;
      minutes: number;
      seconds: number;
    },
    options?: { i18n?: string },
  ) {
    const i18n = options?.i18n || 'cta::remain_time';
    const pad = (time: number) => String(time).padStart(2, '0');

    if (!(days || hours || minutes || seconds)) return '';

    return ET(i18n, {
      days: days ? ET('cta::remain_days', { days }) : '',
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
    });
  }

  private onTick() {
    const [days, hours, minutes, seconds] = BaseDateButtonAction.diff(this.data.end, this.data.start);

    if (!(days || hours || minutes || seconds)) {
      this.timer?.clear();
      this.dispatchEvent(DateEndEvent, { bubbles: true });
    }

    const label = $(this.element()).find('[data-is-limited]');
    label?.setInnerHtml(
      BaseDateButtonAction.convertLabel({
        days,
        hours,
        minutes,
        seconds,
      }),
    );

    this.data.start = `${new Date()}`;
  }
}
